import React, { useState } from "react";
import "animate.css";
import ProductionImg from "../../../assets/Production.png"

function ProductionImprovement() {
  return (
    <div className="animate__animated  animate__zoomIn">
      <div className="container  w-11/12 shadow-5xl  mx-auto  px-8 py-8 my-28">
        <div className="grid grid-cols-2 gap-20 font-Montserrat">
        <div className="md:flex md:flex-col content-start  justify-items-start">
            <div>
              <img
                src={ProductionImg}
                alt="Logo"
                className="h-80  rounded-sm  "
              />
            </div>
          </div>
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <h2 className="text-blue-200 text-2xl font-bold">
             ERP Production Processes Improved
            </h2>
            <p>
              orem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
            </p>
            <button className="bg-blue-200 px-2 py-4 text-white rounded-md w-40 mt-8 hover:bg-blue-100 font-semibold">
              Start free trial
            </button>
          </div>
          
        </div>
      </div>
    </div>
  );
}

export default ProductionImprovement;
